import { useMutation } from '@tanstack/react-query';
import { client } from './api-client';

interface Payment {
  orderRef: string;
  paymentUrl: string;
  total: string;
  transactionCode: string;
}

interface CreatePaymentDto {
  orderRef: string;
}

const useCreatePayment = () =>
  useMutation<Payment, unknown, CreatePaymentDto>(({ orderRef }) =>
    client(`/payment/pay`, {
      method: 'post',
      data: {
        orderRef
      }
    })
  );

const useCreateDijb = () =>
  useMutation<Payment, unknown, CreatePaymentDto>(({ orderRef }) =>
    client(`/payment/dijb`, {
      method: 'post',
      data: {
        orderRef
      }
    })
  );

export { useCreatePayment, useCreateDijb };
